var _g, _path, _path2, _path3, _rect, _path4, _path5, _path6, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBathroomCabinetRefacing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bathroom-cabinet-refacing",
    viewBox: "0 0 171.2 201.9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m166.8 124.5h-30c3.2-2.7 5.3-6.8 5.3-11.4v-8.1c0-1.4-1.1-2.5-2.5-2.5h-12.4v-3.2h1.8v-2.9h-6.4v2.9h1.8v3.2h-7.1v-12.8c0-1 0.4-1.9 1.1-2.6s1.6-1.1 2.6-1.1c2 0 3.7 1.7 3.7 3.7v0.4h2.9v-0.4c0-3.6-3-6.6-6.6-6.6-1.8 0-3.4 0.7-4.7 1.9-1.2 1.2-1.9 2.9-1.9 4.7v12.9h-7.1v-3.2h1.8v-2.9h-6.4v2.9h1.8v3.2h-12.5c-1.4 0-2.5 1.1-2.5 2.5v8.1c0 4.5 2.1 8.6 5.3 11.4h-18.3c3.2-2.7 5.3-6.8 5.3-11.4v-8.1c0-1.4-1.1-2.5-2.5-2.5h-12.4v-3.2h1.8v-2.9h-6.4v2.9h1.7v3.2h-7.1v-12.9c0-1 0.4-1.9 1.1-2.6s1.6-1.1 2.6-1.1c2 0 3.7 1.7 3.7 3.7v0.4h2.9v-0.4c0-3.6-3-6.6-6.6-6.6-1.8 0-3.4 0.7-4.7 1.9-1.2 1.2-1.9 2.9-1.9 4.7v12.9h-7v-3.2h1.8v-2.9h-6.4v2.9h1.8v3.2h-12.5c-1.4 0-2.5 1.1-2.5 2.5v8.1c0 4.5 2.1 8.6 5.3 11.4h-30c-2.5 0-4.5 2-4.5 4.5v6.4c0 2.5 2 4.5 4.5 4.5h5.5v57.6c0 2.5 2 4.5 4.5 4.5h142.4c2.5 0 4.5-2 4.5-4.5v-57.6h5.5c2.5 0 4.5-2 4.5-4.5v-6.5c-0.2-2.5-2.2-4.5-4.6-4.5zm-126.6 0c-4.7-1.6-8.1-6.1-8.1-11.4v-7.6h46.8v7.6c0 5.3-3.4 9.7-8.1 11.4h-30.6zm60.3 0c-4.7-1.6-8.1-6.1-8.1-11.4v-7.6h46.8v7.6c0 5.3-3.4 9.7-8.1 11.4h-30.6zm-87 62.5h32.4v11.4h-31.5c-0.5 0-0.9-0.4-0.9-0.9v-10.5zm32.4-22.6v19h-32.4v-19h32.4zm0-24.5v20.9h-32.4v-20.9h32.4zm3.5 0h33.4v58.5h-33.4v-58.5zm37 0h33.4v58.5h-33.4v-58.5zm36.9 47.1h34.4v10.5c0 0.5-0.4 0.9-0.9 0.9h-33.5v-11.4zm0-3.6v-19h34.4v19h-34.4zm0-22.6v-20.9h34.4v20.9h-34.4zm-119.7-31.8c0-0.5 0.4-0.9 0.9-0.9h162.3c0.5 0 0.9 0.4 0.9 0.9v6.4c0 0.5-0.4 0.9-0.9 0.9h-162.3c-0.5 0-0.9-0.4-0.9-0.9v-6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.5 168.9c-1 0-1.8 0.8-1.8 1.8v6.4c0 1 0.8 1.8 1.8 1.8s1.8-0.8 1.8-1.8v-6.4c-0.1-1-0.9-1.8-1.8-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.7 150.9c0-1-0.8-1.8-1.8-1.8h-6.4c-1 0-1.8 0.8-1.8 1.8s0.8 1.8 1.8 1.8h6.5c0.9 0 1.7-0.8 1.7-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.7 173.8c0-1-0.8-1.8-1.8-1.8h-6.4c-1 0-1.8 0.8-1.8 1.8s0.8 1.8 1.8 1.8h6.5c0.9 0 1.7-0.8 1.7-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.5 150.9c0-1-0.8-1.8-1.8-1.8h-6.4c-1 0-1.8 0.8-1.8 1.8s0.8 1.8 1.8 1.8h6.4c1 0 1.8-0.8 1.8-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.5 173.8c0-1-0.8-1.8-1.8-1.8h-6.4c-1 0-1.8 0.8-1.8 1.8s0.8 1.8 1.8 1.8h6.4c1 0 1.8-0.8 1.8-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.9 170.6v6.4c0 1 0.8 1.8 1.8 1.8s1.8-0.8 1.8-1.8v-6.4c0-1-0.8-1.8-1.8-1.8-1 0.1-1.8 0.9-1.8 1.8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m32 47.4v25.6c0 0.4 0.4 0.8 0.8 0.8h43.9c0.4 0 0.8-0.4 0.8-0.8v-25.6h-45.5zm21.9 24.8h-20.3v-23.2h20.3v23.2zm22 0h-20.3v-23.2h20.3v23.2z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7,60h1.6v3.3h-1.6V60z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2,60h1.6v3.3h-1.6V60z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.8,
    y: 1.2,
    width: 43.9,
    height: 42.2,
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m91.9 47.4v25.6c0 0.4 0.4 0.8 0.8 0.8h43.9c0.4 0 0.8-0.4 0.8-0.8v-25.6h-45.5zm21.9 24.8h-20.3v-23.2h20.3v23.2zm22 0h-20.3v-23.2h20.3v23.2z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.6,60h1.6v3.3h-1.6V60z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.1,60h1.6v3.3h-1.6V60z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 92.7,
    y: 1.2,
    width: 43.9,
    height: 42.2,
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathroomCabinetRefacing);
export default __webpack_public_path__ + "static/media/bathroom-cabinet-refacing.8c944930dc7d86fd8555052f554b336c.svg";
export { ForwardRef as ReactComponent };